import type { TOC } from '@ember/component/template-only'
import type BookLibrarySharesByStudentController from 'teacher-ui-client/subscription-type/book-library/shares/index/by-student/controller'
import { BookLibraryStudentsTable } from 'teacher-ui-client/components/book-library/students-table'
import RouteTemplate from 'ember-route-template'

interface Signature {
  Args: {
    controller: BookLibrarySharesByStudentController
  }
}
export const BookLibrarySharesIndexByStudentPage: TOC<Signature> = <template>
  <BookLibraryStudentsTable class="min-w-full table-fixed" @expandedStudentId={{@controller.expandedStudentId}}>
    <:expandedRow>{{outlet}}</:expandedRow>
  </BookLibraryStudentsTable>
</template>

export default RouteTemplate(BookLibrarySharesIndexByStudentPage)
